module.exports = __webpack_public_path__ + "static/media/mail.b644c32d.svg";